function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Bounding_Boxes"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_3",
  display: "none"
}), React.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Rounded",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_5"
}), React.createElement("g", {
  display: "inline"
}, React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,17L12,17c-0.55,0-1-0.45-1-1v-4 c0-0.55,0.45-1,1-1h0c0.55,0,1,0.45,1,1v4C13,16.55,12.55,17,12,17z M13,9h-2V7h2V9z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Sharp",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_4"
}), React.createElement("g", {
  display: "inline"
}, React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Outline"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header",
  display: "none"
}), React.createElement("g", null, React.createElement("rect", {
  x: 11,
  y: 7,
  width: 2,
  height: 2
}), React.createElement("rect", {
  x: 11,
  y: 11,
  width: 2,
  height: 6
}), React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 c0-4.41,3.59-8,8-8s8,3.59,8,8C20,16.41,16.41,20,12,20z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Duotone",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_2"
}), React.createElement("g", {
  display: "inline"
}, React.createElement("path", {
  opacity: 0.3,
  d: "M12,4c-4.41,0-8,3.59-8,8c0,4.41,3.59,8,8,8s8-3.59,8-8C20,7.59,16.41,4,12,4z M13,17h-2v-6h2V17z M13,9h-2 V7h2V9z"
}), React.createElement("rect", {
  x: 11,
  y: 7,
  width: 2,
  height: 2
}), React.createElement("rect", {
  x: 11,
  y: 11,
  width: 2,
  height: 6
}), React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 c0-4.41,3.59-8,8-8s8,3.59,8,8C20,16.41,16.41,20,12,20z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Material",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy"
}), React.createElement("g", {
  display: "inline"
}, React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgComponent;


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/info.inline.svg
// module id = 1001
// module chunks = 37